import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { apiUrl } from 'src/environments/environment';
import { LoginConstants } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private baseUrl: string = apiUrl.MAXGP_HOST_DIRECT;
  constructor(private http: HttpClient) {}

  public loginForTransaction(user: any, password: any): Observable<any> {
    let loginData = {
      user: user,
      password: password,
    };

    const headers = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Empresa: 'infodec',
        Accept: 'application/json',
      }),
    };

    return this.http
      .post<any>(
        `${this.baseUrl}/webservice/api/V1/system/auth/`,
        loginData,
        headers
      )
      .pipe(catchError(this.handleError));
  }
  private handleError(errorResponse: HttpErrorResponse) {
    return throwError(errorResponse);
  }
}
